/*eslint-disable */

export function getParts(state) {
    return state.items;
}

export function getCategories(state) {
    return state.categories;
}